import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { List as ImmutableList } from 'immutable';
import { useContext, useMemo } from 'react';
import { SelectedReports } from 'reporting-action-components/reportingActions/exportReport/ExportReportButton';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { setConfigReportLimit } from 'reporting-data/report/configReportSetters';
import { getIsReportValidForChartType, transformReportChartType } from 'reporting-data/report/report-transformations/chartTypeTransformations';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import ErrorBoundaryDecorator from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
import { getMetricsFromSelectedTableMetricValues } from '../../../reportEditors/TableMetricEditor/tableMetricEditorUtils';
import { useTableRowLimit } from '../../common/hooks/useTableRowLimit';
import { SRVSummarizedTableActionsBar } from '../../common/srv-table/SRVSummarizedTableActionsBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function updateReportMetrics(report, additionalMetrics = ImmutableList()) {
  const selectedTableMetrics = getMetricsFromSelectedTableMetricValues(report);
  const metrics = selectedTableMetrics.merge(additionalMetrics);
  return report.updateIn(['config', 'metrics'], currentMetrics => metrics && !metrics.isEmpty() ? currentMetrics.concat(metrics).toSet().toList() : currentMetrics);
}
function convertToTableReport({
  report,
  rowLimit,
  onRowLimitChange,
  additionalMetrics
}) {
  // getIsReportValidForChartType will return false if the report type is already TABLE, but that is a valid case for us
  if (getReportChartType(report) !== TABLE && !getIsReportValidForChartType(report, TABLE, [])) {
    return;
  }
  let tableReport = getReportChartType(report) !== TABLE ? transformReportChartType(report, TABLE) : report;
  tableReport = updateReportMetrics(tableReport, additionalMetrics);
  return setConfigReportLimit(tableReport, rowLimit).setIn(['displayParams', 'rowsPerPage', 'onChange'], onRowLimitChange).setIn(['displayParams', 'showTotals'], true);
}
function SRVSummarizedTableTimeSeriesReportInner({
  previewReport,
  onPreviewReportChange,
  additionalMetrics,
  suppressActionsBar = false
}) {
  const {
    trackingApplicationName,
    trackingAssetType,
    trackingScreenName
  } = useContext(EnablementTrackingContext);
  const {
    rowLimit,
    onRowLimitChange
  } = useTableRowLimit();
  const tableReport = useMemo(() => convertToTableReport({
    report: previewReport,
    rowLimit,
    onRowLimitChange,
    additionalMetrics
  }), [previewReport, rowLimit, onRowLimitChange, additionalMetrics]);
  if (!tableReport) {
    return /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      marginBlockStart: "1000",
      children: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.singleReportViewer.tables.summarizedDisabled"
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!suppressActionsBar && /*#__PURE__*/_jsx(SRVSummarizedTableActionsBar, {
      previewReport: previewReport,
      tableReport: tableReport,
      onPreviewReportChange: onPreviewReportChange,
      selectedReport: SelectedReports.summarizedTable
    }), /*#__PURE__*/_jsx(PlatformReportResolver, {
      lazyReportResolve: false,
      report: tableReport,
      useInlineLabels: false,
      trackingApplicationName: trackingApplicationName,
      trackingAssetType: trackingAssetType,
      trackingScreenName: trackingScreenName,
      enableReportResolveUsageTracking: false
    })]
  });
}
export const SRVSummarizedTableTimeSeriesReport = ErrorBoundaryDecorator(SRVSummarizedTableTimeSeriesReportInner, 'SRVSummarizedTableTimeSeriesReport');